export const EVENTS = {
  SIGN_IN: 'SIGN_IN',
  SIGN_OUT: 'SIGN_OUT',
  SELECT_ADDRESS: 'SELECT_ADDRESS',
  SCROLL_AT_TOP: 'SCROLL_AT_TOP',
};
